import { bool, func, array, string, oneOf, oneOfType } from 'prop-types'
import { ColorsWrapper, ColorsSwatches } from './tile.styled'
import Typography from '../../atoms/typography'
import Swatch from '../swatch'
import { useTheme } from '@mui/system'

const Colors = ({ position, expanded, colors, label, onClick, onHover }) => {
	const theme = useTheme()

	return (
		<ColorsWrapper position={position}>
			{expanded ? (
				<ColorsSwatches>
					{colors.map((color, index) => (
						<div
							key={color.code}
							onClick={(event) => {
								if (onClick) {
									onClick(event, {
										code: color.code,
										label: color.label,
									})
								}
							}}
							onMouseOver={(event) => {
								if (onHover) {
									onHover(event, {
										code: color.code,
										label: color.label,
									})
								}
							}}
						>
							<Swatch hex={color.hex} src={color.src} id={index} label={color.label} value={color.code} />
						</div>
					))}
				</ColorsSwatches>
			) : (
				<Typography component="span" color={theme.palette.grey.medium}>
					{label}
				</Typography>
			)}
		</ColorsWrapper>
	)
}

Colors.propTypes = {
	position: oneOfType([oneOf(['inner', 'outer']), string]),
	expanded: bool,
	label: string,
	colors: array,
	onClick: func,
	onHover: func,
}

export default Colors
